import React, {Component} from 'react';

/**
 * Questo plugin serve solamente per gestire l'iscrizione a due corsi contemporaneamente (lato BE)
 * per cui il plugin FE iscrizione è vuoto. ritorna solametne i codici corso a cui verrà iscritto il corsista.
 */
export class FormDIGCOMP extends Component {
    
    state = {  
        courses: ['DIGCOMP2_2','DIGCOMPEDU']    
    }

    getValue(){

        const items = this.state.courses.map(item =>{
            return {code: item}
        });

        const pluginValue = { 
            courses: items,
        };
                
        return pluginValue;
    }

    checkValidation() {
        
        const isValid = true; 

        return (isValid);       
    }    


    render() {

        return (
            <>               
            </>
        );
    }
}